// core version + navigation, pagination modules:
import Swiper from 'swiper';
import {Autoplay, Navigation, Pagination, Scrollbar, Keyboard, A11y} from 'swiper/modules';

class CustomSwiper {
    /**
     *
     * @param element {HTMLElement}
     */
    constructor(element) {

        let params = {
            enabled: true,
            watchOverflow: true,
            modules: [Keyboard, A11y, Autoplay],
            autoplay: {
                enabled: false,
            }
        }

        let withNavigation = Boolean(element.dataset['swiperNavigation']);
        if (withNavigation) {
            params.navigation = {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            }
            params.modules = [...params.modules, Navigation]
        }
        let withPagination = Boolean(element.dataset['swiperPagination']);
        if (withPagination) {
            params.pagination = {
                el: '.swiper-pagination',
                clickable: true,
            }
            params.modules = [...params.modules, Pagination]
        }
        let withScrollbar = Boolean(element.dataset['swiperScrollbar']);
        if (withScrollbar) {
            params.scrollbar = {
                el: '.swiper-scrollbar',
            }
            params.modules = [...params.modules, Scrollbar]
        }
        let swiperMobileSlidesPerView = element.dataset['swiperMobileSlidesPerView'];
        let swiperMobileSpaceBetween = element.dataset['swiperMobileSpaceBetween'];

        params.slidesPerView = swiperMobileSlidesPerView ?? 1;
        params.spaceBetween = swiperMobileSpaceBetween ?? 10;

        let swiperSlidesPerView = element.dataset['swiperSlidesPerView'];
        let swiperSpaceBetween = element.dataset['swiperSpaceBetween'];

        params.breakpoints = {
            992: {
                slidesPerView: swiperSlidesPerView,
                spaceBetween: swiperSpaceBetween,
            }
        }

        let swiperAutoplayDelay = element.dataset['swiperAutoplayDelay'];
        if (swiperAutoplayDelay) {
            params.breakpoints[992].autoplay = {
                enabled: true,
                delay: Number.parseInt(swiperAutoplayDelay),
                pauseOnMouseEnter: true,
            }
        }
        this.instance = new Swiper(element, params);
        // console.log(this);
    }
}

document.querySelectorAll('.swiper').forEach(container => {
    const swiper = new CustomSwiper(container);
});


//Swiper configuration
//if (document.querySelector('.swiper')) {
//    const swiper = new CustomSwiper(document.getElementsByClassName('swiper')[0]);
//}


// Get all elements with class 'post'
//var posts = document.querySelectorAll('.post');

// Filter out elements that do not contain a child with tag 'blockquote'
//var filteredPosts = Array.from(posts).filter(function(post) {
//    return !post.querySelector('blockquote');
//});

//filteredPosts.forEach( (post, index = 0) => {
//    if (index % 2 == 0) {
//        post.style.backgroundColor = '#f2f2f2';
//    }
//});

//sort blockquotes

if (document.querySelectorAll(".post blockquote")) {

    document.addEventListener("DOMContentLoaded", function() {
        // Find all posts
        const postElements = document.querySelectorAll('.post');

        // Reverse the order of the post elements
        const reversedPostElements = Array.from(postElements).reverse();

        // Loop through each post in reverse order
        reversedPostElements.forEach(function(post) {
            // Find the innermost blockquote within the post
            const blockquotes = post.querySelectorAll('.content blockquote');
            const innermostBlockquote = blockquotes[blockquotes.length - 1];

            if (innermostBlockquote) {
                // Get the data-post-id from the innermost blockquote's parent link
                const link = innermostBlockquote.querySelector("a[data-post-id]");
                const dataPostId = link.getAttribute("data-post-id");

                // Find the post with the corresponding data-post-id
                const targetPost = document.querySelector(`#p${dataPostId}`);

                if (targetPost) {
                    // Move the current post after the target post
                    targetPost.parentNode.insertBefore(post, targetPost.nextSibling);
                    post.style.backgroundColor =  targetPost.style.backgroundColor;
                }
            }
        });
    });
}

if (document.querySelector('.post')) {
    // Alle Post-Elemente auswählen
    document.addEventListener("DOMContentLoaded", function () {
        const postElements = document.querySelectorAll('.post');
        postElements.forEach((postElement, index) => {
            const blockquote = postElement.querySelector('.content blockquote');

            if (blockquote) {
                const nextPost = postElements[index + 1];
                const nextBlockquote = nextPost ? nextPost.querySelector('.content blockquote') : null;

                if (!nextBlockquote) {
                    //postElement.style.borderBottom = '1px solid #2CA67B';
                    //postElement.style.marginBottom = '4rem';
                    postElement.style.paddingLeft = '2.5rem';
                } else {
                    postElement.style.paddingLeft = '2.5rem';
                }
            }
        });
    });
}


//optimized sorting

document.addEventListener("DOMContentLoaded", function () {
    const posts = document.querySelectorAll('.post');

    posts.forEach((post) => {
        post.style.backgroundColor = '#ffffff';
    })

    // Filter posts without blockquote
    const filteredPosts = Array.from(posts).filter(post => !post.querySelector('blockquote'));

    filteredPosts.forEach((post, index) => {
        post.style.backgroundColor = '#ffffff';

        if (index % 2 === 0) {
            post.style.backgroundColor = '#f2f2f2';
        }
        else {
            post.style.backgroundColor = '#ffffff';
        }
    });

    // Sort blockquotes
    const postElements = document.querySelectorAll('.post');
    Array.from(postElements).reverse().forEach(post => {
        const blockquotes = post.querySelectorAll('.content blockquote');
        const innermostBlockquote = blockquotes[blockquotes.length - 1];

        if (innermostBlockquote) {
            const link = innermostBlockquote.querySelector("a[data-post-id]");
            const dataPostId = link.getAttribute("data-post-id");

            const targetPost = document.querySelector(`#p${dataPostId}`);

            if (targetPost) {
                targetPost.parentNode.insertBefore(post, targetPost.nextSibling);
                post.style.backgroundColor = targetPost.style.backgroundColor;

                /*
                if (targetPost.style.borderLeft === "2px solid lightgrey") {

                    targetPost.style.borderBottom = "none";
                    post.style.borderLeft = "2px solid lightgrey";
                    post.style.borderRight = "2px solid lightgrey";
                    //post.style.borderBottom = "none";
                    //post.style.borderTop = "none";

                }
                */
            }
        }
    });

    // Adjust styles for posts with blockquotes
    posts.forEach((postElement, index) => {
        const blockquote = postElement.querySelector('.content blockquote');
        const nextPost = posts[index + 1];
        const nextBlockquote = nextPost ? nextPost.querySelector('.content blockquote') : null;

        if (blockquote && !nextBlockquote) {
            postElement.style.paddingLeft = '2.5rem';
        } else {
            postElement.style.paddingLeft = '2.5rem';
        }
    });



    const postElementsTwo = document.querySelectorAll('.post:not(:has(blockquote))');
    //console.log(postElementsTwo);


    postElementsTwo.forEach((post, index) => {
        //const questions = post;
        let nextSibling = getNextElementSibling(post);

        let hasNextSibling = true;

        if (post.style.backgroundColor === "rgb(255, 255, 255)") {
            post.style.borderLeft = "2px solid lightgrey";
            post.style.borderRight = "2px solid lightgrey";
            post.style.borderTop = "2px solid lightgrey";

            if (nextSibling?.style?.backgroundColor === post.style.backgroundColor) {
                post.style.borderBottom = "none";
                nextSibling.style.borderLeft = "2px solid lightgrey";
                nextSibling.style.borderRight = "2px solid lightgrey";

                while (hasNextSibling) {

                    if (nextSibling.nextSibling?.style?.backgroundColor === "rgb(255, 255, 255)") {

                        nextSibling.style.borderLeft = "2px solid lightgrey";
                        nextSibling.style.borderRight = "2px solid lightgrey";

                        nextSibling = getNextElementSibling(nextSibling);

                    }
                    else {
                        hasNextSibling = false;
                        nextSibling.style.borderLeft = "2px solid lightgrey";
                        nextSibling.style.borderRight = "2px solid lightgrey";
                        nextSibling.style.borderBottom = "2px solid lightgrey";
                    }

                }

            }
            else {
                post.style.borderBottom = "2px solid lightgrey";
            }

        }


    });
});


/*
const subjectField = document.querySelector("input#subject");
const messageField = document.querySelector("textarea#message");

if (messageField) {
    console.log(messageField.value);
    console.log(messageField.value.includes("[/quote]"));

    if (messageField.value.includes("[/quote]") && messageField.value.includes("[quote=")) {
        subjectField.value = '';
    }
}
 */

function getNextElementSibling(node) {

    while (node && (node = node.nextSibling)) {
        if (node.nodeType == 1) {
            return node;
        }
    }
    // return undefined
}